import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import rootReducer from "../reducers";

let middleware = [ thunkMiddleware ];

if (process.env.NODE_ENV !== "production") {
  const loggerMiddleware = createLogger();
  middleware = [ ...middleware, loggerMiddleware ];
}

function configureStore(initialState) {
  return createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middleware)
  );
}

export default configureStore;
